import React, { useMemo } from 'react';
import { View } from '@fairygodboss/ui';

import { useJobSearchContext } from '../../../contexts/JobSearchContext';
import { JobsSearchFilter } from './JobsSearchResults/JobsSearchFilter';

export const JobsSearchFilterWrapper = () => {
    const {
        filterJobs,
        filters,
        activeFilters,
        clearFilters,
        setFilterByType,
        isAuthenticatedUser,
    } = useJobSearchContext();

    return useMemo(
        () => (
            <View boxShadow="smallDown" zIndex="3" position="relative">
                <JobsSearchFilter
                    isAuthenticatedUser={isAuthenticatedUser}
                    setFilterByType={setFilterByType}
                    activeFilters={activeFilters}
                    onClearFilters={clearFilters}
                    filterJobs={filterJobs}
                    locationList={filters?.locations}
                    companyList={filters?.company_id}
                    hasRemote={!!filters?.remote?.length}
                />
            </View>
        ),
        [
            isAuthenticatedUser,
            setFilterByType,
            activeFilters,
            clearFilters,
            filterJobs,
            filters,
        ]
    );
};
